import React from 'react';
import FadeIn from '../components/ui/FadeIn';

const Terms = () => {
  const terms = [
    { title: "1. BOOKINGS & PAYMENTS", text: "A deposit is required to secure all bookings. Deposits are non-refundable. Your booking is only confirmed once payment is received. Remaining balances must be paid before or on the day of your session." },
    { title: "2. RESCHEDULING", text: "Clients may reschedule once within 30 days of the original date. Requests must be made 48 hours in advance." },
    { title: "3. CANCELLATIONS", text: "All payments are non-refundable. Deposits may be transferred to a future booking within 30 days subject to availability." },
    { title: "4. LATE ARRIVALS", text: "Late arrivals result in reduced session time. Sessions end at the scheduled time regardless." },
    { title: "5. NO-SHOWS", text: "Failure to attend without notice results in a forfeited booking and payment." },
    { title: "6. IMAGE DELIVERY", text: "Final edited images delivered within communicated timeframes. Rush delivery incurs extra charges." },
    { title: "7. CREATIVE DIRECTION", text: "LB Brand Haus maintains creative direction to ensure quality consistency." },
    { title: "8. USE OF IMAGES", text: "LB Brand Haus reserves the right to use media for marketing and portfolio. Notify us in writing prior to session if you prefer otherwise." },
    { title: "9. LIABILITY", text: "Clients are responsible for equipment damages. LB Brand Haus is not responsible for personal injury or lost belongings." },
    { title: "10. STUDIO RENTAL", text: "Full payment required to secure rental. Space must be left in original condition." },
  ];

  return (
    <div className="pt-40 pb-40 bg-brand-bone">
      <div className="container mx-auto px-6 max-w-4xl">
        <FadeIn className="mb-20 text-center">
          <h1 className="text-5xl font-heading mb-6">Terms & Conditions</h1>
          <p className="text-lg italic serif-italic opacity-70">By booking with LB Brand Haus, you agree to the following terms.</p>
        </FadeIn>
        
        <div className="space-y-12 bg-white p-12 md:p-20 rounded-[3rem] shadow-sm">
          {terms.map((t, i) => (
            <div key={i}>
              <h3 className="text-[10px] font-bold tracking-widest uppercase text-brand-orange mb-4">{t.title}</h3>
              <p className="text-sm leading-relaxed opacity-80">{t.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Terms;